import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bibliotheque-multimedia',
  templateUrl: './bibliotheque-multimedia.component.html',
  styleUrls: ['./bibliotheque-multimedia.component.css']
})
export class BibliothequeMultimediaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
